import {get} from 'lodash';
import {processUserProfile} from './userProfile';
import {formatDateTimes} from 'utils/formator';
import { convertSource } from 'page/app/ConstantGroup';

export const processFiatAccountList = (rawData) => {
    return {
        ...rawData,
        clientDetail: processUserProfile(get(rawData, ':user')),
        id: get(rawData, 'id'),
        balance: Number(get(rawData, 'balance')),
        availableBalance: Number(get(rawData, 'availableBalance')),
        // status: get(rawData, 'status'),
        status: 'activated',
        currency: get(rawData, 'currency'),
        country: get(rawData, ':currency.entity') === 'EU_EZ'
                ? 'EU'
                : get(rawData, ':currency.entity'),
    };
};


export const processCryptoAccountList = (rawData) => {
    return {
        ...rawData,
        id: get(rawData, 'id'),
        balance: Number(get(rawData, 'balance')),
        availableBalance: Number(get(rawData, 'availableBalance')),
        status: get(rawData, 'status'),
        crypto: get(rawData, 'crypto'),
    };
};
